import React from 'react';

import './Login.css';
import Hosts from '../../Hosts'

import {

	repo_logo_link,
	repo_img_link,

} from '../../Utils';


// or
//import { Tabs } from '@material-ui/core';
import RecuperarForm from "./RecuperarForm";

const Recuperar = ({ setToken }) => {
  return (
    <div>

      <div className="login-wrapper">
        <div className="div-left" style={{
          backgroundImage: `url(` + repo_img_link("img-login.jpg") + `)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>

        </div>
        <div className="div-right">
          <div className="form-header">
            <a href={Hosts.WEB_SITE_URI} rel="noreferrer" target="_blank">
              <img alt='' src={repo_logo_link("logo.svg")} />      
            </a>      
          </div>

          <div className="div-form">            
            <RecuperarForm setToken={setToken} loginType='recuperar' />            
          </div>
          <div className="form-footer">
            {/*Intermediário de Crédito autorizado pelo Banco de Portugal n.º 2749*/}
          </div>
        </div>
      </div>

    </div>

  );

}

export default Recuperar;

